<template>
  <div class="navigation">
    <div class="left">
      <img src="@/assets/navLogo.png" alt="" />
    </div>
    <div class="right">
      <div class="navigationItem" @click="getRouter('/')" :class="selectIndex === '/' ? 'navSelect' : ''" >首页</div>
      <div class="navigationItem" @click="getRouter('/aboutUs')" :class="selectIndex === '/aboutUs' ? 'navSelect' : ''">关于我们</div>
      <button class="rightBtn">
        <a href="https://rms.retouchspace.com" target="_blank">免费注册/登录</a>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectIndex: "",
    };
  },
  created() {
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        window.scrollTo(0, 0);
        let path = val.path;
        this.selectIndex = path;
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted() {},
  methods: {
    getRouter(e) {
      let router = this.$route.path;
      if (e !== router) {
        localStorage.setItem("selectStatus", e);
        this.selectIndex = e;
        this.$router.push({
          path: e,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.navigation {
  height: 70px;
  background: #ffffff;
  box-shadow: 0px 1px 0px 0px #f7f9fc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 60px;
  position: sticky;
  z-index: 99;
  top: 0;
  left: 0;
  .left {
    height: 28px;
    img {
      width: 174px;
    }
  }
  .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .navigationItem {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #242e42;
    line-height: 16px;
    margin-right: 70px;
    cursor: pointer;
  }
  .rightBtn {
    width: 136px;
    height: 40px;
    background: #0064ff;
    border-radius: 8px;
    border: none;
    outline: none;
    cursor: pointer;
    a {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #ffffff;
      display: block;
    }
  }
  .navSelect {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #0064ff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue